<template>
	<modal
		:name="name"
		height="auto"
		:width="width"
		:minWidth="minWidth"
		:clickToClose="clickToClose"
		@before-open="$emit('before-open')"
		@before-close="$emit('before-close')"
		@opened="$emit('opened')"
		@closed="$emit('closed')"
		ref="ref"
	>
		<slot />
	</modal>
</template>

<script>
export default {
	props : {
		name : {
			type     : String,
			required : true
		},
		width : {
			type     : Number,
			required : false
		},
		minWidth : {
			type     : Number,
			required : false
		},
		clickToClose : {
			type : Boolean,
			default () {
				return true
			}
		}
	}
}
</script>

<style lang="scss">
body .v--modal-overlay {
	background: rgba(255, 255, 255, 0.7);

	.v--modal {
		color: #41495B;
		border-radius: 5px;

		&-box {
			overflow: visible;
		}

		.header {
			color: #fff;
			background: #41495B;
			padding: 14px 20px;
			font-size: 18px;
			font-weight: 700;
			display: flex;
			align-items: center;
			max-height: 50px;
			border-radius: 5px 5px 0 0;

			svg {
				width: 20px;
				margin-right: 10px;
			}

			.close {
				color: #fff;
				display: flex;
				flex-grow: 1;
				max-height: 50px;
				justify-content: flex-end;
				align-items: center;

				button {
					display: flex;
					align-items: center;
				}

				svg {
					width: 16px !important;
					height: 16px;
					margin-right: 0;
					cursor: pointer;
				}
			}
		}

		.content {
			padding: 20px;
		}
	}
}
</style>
